import { type ValueOf } from '@models/helpers/custom'

export const DateTimeUnits = {
  YEAR: 'year',
  YEARS: 'years',
  QUARTER: 'quarter',
  QUARTERS: 'quarters',
  MONTH: 'month',
  MONTHS: 'months',
  WEEK: 'week',
  WEEKS: 'weeks',
  DAY: 'day',
  DAYS: 'days',
  HOUR: 'hour',
  HOURS: 'hours',
  MINUTE: 'minute',
  MINUTES: 'minutes',
  SECOND: 'second',
  SECONDS: 'seconds',
  MILLISECOND: 'millisecond',
  MILLISECONDS: 'milliseconds'
} as const

export const DateTimeShortUnits = {
  YEAR: 'year',
  QUARTER: 'quarter',
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  HOUR: 'hour',
  MINUTE: 'minute',
  SECOND: 'second',
  MILLISECOND: 'millisecond'
} as const

export type DateTimeUnitsType = ValueOf<typeof DateTimeUnits>
export type DateTimeShortUnitsType = ValueOf<typeof DateTimeShortUnits>

export type DateTimeDurationType = {
  [key in DateTimeUnitsType]?: number;
}
